import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Vue, Watch, PropSync, Prop } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
import { QuestionType, DecorationType } from "@/modules/newCommunity/pages/operationTools/config/newQuestionnaire";
// 机审题型配置定义：机审题型配置下可包含多种机审题型，后续扩展其他机审题型时在此追加一项，并在 itemProperty 中新增对应字段
const machineAuditTypeConfigs = [{
  type: "SCALE",
  name: "量表题",
  itemIdsField: "scaleItemIds",
  candidateComponentNames: [QuestionType.singleChoice, QuestionType.singleChoicePicker]
}];
let MachineAuditTypeSetting = class MachineAuditTypeSetting extends Vue {
  constructor() {
    super(...arguments);
    // 机审题型配置定义列表
    this.auditTypeConfigs = machineAuditTypeConfigs;
    // 弹窗内临时选择：{ [机审题型type]: 题目ID数组 }，打开弹窗时回显，仅影响展示
    this.tempSelected = {};
    // 打开弹窗时检测到的失效（已删除）题目数量
    this.invalidCount = 0;
  }
  get dataList() {
    return QuestionnaireEditModule.dataList;
  }
  get itemProperty() {
    return QuestionnaireEditModule.itemProperty;
  }
  // 非装饰组件题目列表（用于计算题号，与逻辑设置的题号口径一致）
  get questionItems() {
    return this.dataList.filter(item => {
      return ![DecorationType.picture, DecorationType.text, DecorationType.cutOffLine, DecorationType.pageGap, DecorationType.calculator].includes(item.componentName);
    });
  }
  // 指定机审题型对应的候选题目（由其配置的表单题型范围决定）
  candidateItemsOf(cfg) {
    return this.questionItems.filter(item => {
      return cfg.candidateComponentNames.includes(item.componentName);
    });
  }
  inputValChange(val) {
    if (val) {
      this.initData();
    }
  }
  // 打开弹窗时初始化：回显已选题目，并过滤失效（已删除）题目（仅影响展示，不修改 store）
  initData() {
    const validIds = this.dataList.map(item => item.data.id);
    let invalidCount = 0;
    const tempSelected = {};
    this.auditTypeConfigs.forEach(cfg => {
      const ids = (this.itemProperty && this.itemProperty[cfg.itemIdsField] || []).slice();
      invalidCount += ids.filter(id => !validIds.includes(id)).length;
      tempSelected[cfg.type] = ids.filter(id => validIds.includes(id));
    });
    this.invalidCount = invalidCount;
    this.tempSelected = tempSelected;
  }
  // 题目展示：序号.题目标题（序号为表单中题目顺序，与逻辑设置一致）
  formatLabel(item) {
    const index = this.questionItems.findIndex(o => o.data.id === item.data.id);
    return `${index + 1}.${item.data.title}`;
  }
  /**
   * 统一校验函数：校验 itemProperty 中所有机审题型配置字段是否存在失效（已删除）的题目 ID。
   * 三个调用时机共用：
   *  1) 弹窗打开：过滤失效题目仅用于展示，不修改 store；
   *  2) 弹窗保存：过滤失效题目后写入 store；
   *  3) 提交问卷前（CHECK_DATA_validate 链路）：发现失效题目则阻止提交。
   * 返回：{ valid: boolean; invalidIds: string[] }
   */
  validateForSave() {
    const validIds = this.dataList.map(item => item.data.id);
    let invalidIds = [];
    this.auditTypeConfigs.forEach(cfg => {
      const ids = this.itemProperty && this.itemProperty[cfg.itemIdsField] || [];
      invalidIds = invalidIds.concat(ids.filter(id => !validIds.includes(id)));
    });
    return {
      valid: invalidIds.length === 0,
      invalidIds
    };
  }
  // 保存：按机审题型配置列表组装数据，过滤失效题目后写入 store，并关闭弹窗
  handleSave() {
    const validIds = this.dataList.map(item => item.data.id);
    const payload = {
      ...this.itemProperty
    };
    this.auditTypeConfigs.forEach(cfg => {
      const cleanIds = (this.tempSelected[cfg.type] || []).filter(id => validIds.includes(id));
      payload[cfg.itemIdsField] = cleanIds;
    });
    QuestionnaireEditModule.SET_itemProperty(payload);
    this.visible = false;
  }
  // 取消：放弃本次修改，恢复打开弹窗前的已配置状态
  handleCancel() {
    this.visible = false;
  }
};
__decorate([PropSync("modalVisible", {
  type: Boolean
})], MachineAuditTypeSetting.prototype, "visible", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], MachineAuditTypeSetting.prototype, "disabled", void 0);
__decorate([Watch("visible")], MachineAuditTypeSetting.prototype, "inputValChange", null);
MachineAuditTypeSetting = __decorate([Component({
  name: "machineAuditTypeSetting",
  components: {},
  filters: {}
})], MachineAuditTypeSetting);
export default MachineAuditTypeSetting;